var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 284.91 288.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3{opacity:0.3;}.cls-2{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10,.cls-17,.cls-23,.cls-24,.cls-26{fill:#fff;}.cls-10{opacity:0.56;}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-11);}.cls-15{fill:url(#linear-gradient-12);}.cls-16{fill:url(#linear-gradient-13);}.cls-17{mix-blend-mode:soft-light;}.cls-18{fill:url(#linear-gradient-14);}.cls-19{fill:url(#linear-gradient-15);}.cls-20{fill:url(#linear-gradient-16);}.cls-21{fill:url(#linear-gradient-17);}.cls-22{fill:url(#linear-gradient-18);}.cls-23,.cls-25{opacity:0.6;}.cls-24{opacity:0.78;}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32{fill:url(#linear-gradient-24);}.cls-33{fill:url(#linear-gradient-25);}.cls-34{fill:url(#linear-gradient-26);}.cls-35{fill:url(#linear-gradient-27);}.cls-36{fill:url(#linear-gradient-28);}.cls-37{fill:url(#linear-gradient-29);}.cls-38{fill:url(#linear-gradient-30);}.cls-39{fill:url(#linear-gradient-31);}.cls-40{fill:url(#linear-gradient-32);}.cls-41{fill:url(#linear-gradient-33);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-35);}.cls-44{fill:url(#linear-gradient-36);}.cls-45{fill:url(#linear-gradient-37);}.cls-46{fill:url(#linear-gradient-38);}.cls-47{fill:url(#linear-gradient-39);}.cls-48{fill:url(#linear-gradient-40);}.cls-49{fill:url(#linear-gradient-41);}.cls-50{fill:url(#linear-gradient-42);}.cls-51{fill:url(#linear-gradient-43);}.cls-52{fill:url(#linear-gradient-44);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 454.88,
    y1: 372.53,
    x2: 241.74,
    y2: 186.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#937db9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da99c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -362.38,
    y1: 3413.12,
    x2: -315.02,
    y2: 3413.12,
    gradientTransform: "matrix(0.05, 1, 1, -0.05, -3224.73, 671.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -312.72,
    y1: 3400.64,
    x2: -309.95,
    y2: 3400.64,
    gradientTransform: "matrix(0.05, 1, 1, -0.05, -3224.73, 671.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -298.36,
    y1: 3421.78,
    x2: -296.46,
    y2: 3421.78,
    gradientTransform: "matrix(0.05, 1, 1, -0.05, -3224.73, 671.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -344.83,
    y1: 3443.36,
    x2: -296.06,
    y2: 3443.36,
    gradientTransform: "matrix(0.05, 1, 1, -0.05, -3224.73, 671.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -349.7,
    y1: 3453.65,
    x2: -346.97,
    y2: 3453.65,
    gradientTransform: "matrix(0.05, 1, 1, -0.05, -3224.73, 671.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1267.14,
    y1: 3348.38,
    x2: -1085.63,
    y2: 3592.57,
    gradientTransform: "matrix(0.01, -1, 1, 0.01, -3260.95, -1062.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c4997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4b7b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -405.59,
    y1: 3440.08,
    x2: -404.24,
    y2: 3440.08,
    gradientTransform: "matrix(0.05, 1, 1, -0.05, -3224.73, 671.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -406.13,
    y1: 3424.91,
    x2: -379.68,
    y2: 3424.91,
    gradientTransform: "matrix(0.05, 1, 1, -0.05, -3224.73, 671.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -394.32,
    y1: 3450.27,
    x2: -364.13,
    y2: 3450.27,
    gradientTransform: "matrix(0.05, 1, 1, -0.05, -3224.73, 671.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -397.64,
    y1: 3452.16,
    x2: -395.58,
    y2: 3452.16,
    gradientTransform: "matrix(0.05, 1, 1, -0.05, -3224.73, 671.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1234.74,
    y1: 3321.46,
    x2: -1053.23,
    y2: 3565.65,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -328.03,
    y1: 1332.14,
    x2: -203.58,
    y2: 1332.14,
    gradientTransform: "matrix(-0.96, 0.28, 0.28, 0.96, -251.83, -1010.69)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -3599.23,
    y1: -734.64,
    x2: -3446.57,
    y2: -734.64,
    gradientTransform: "matrix(-0.1, -0.99, -0.99, 0.1, -692.45, -3167.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643c90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 281.91,
    y1: 347.18,
    x2: 268.15,
    y2: -60.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201d3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 243.38,
    y1: 261.61,
    x2: 142.17,
    y2: 466.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cc9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c519f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 165.28,
    y1: 289.52,
    x2: 321.19,
    y2: 388.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 391.55,
    y1: 85.67,
    x2: 120.51,
    y2: 447.52,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 255.97,
    y1: 208.44,
    x2: 201.5,
    y2: 301.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 265.94,
    y1: 214.28,
    x2: 211.47,
    y2: 307.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 274.32,
    y1: 237.19,
    x2: 202.66,
    y2: 337.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 285.88,
    y1: 225.96,
    x2: 231.42,
    y2: 318.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 303.47,
    y1: 63.16,
    x2: 234.67,
    y2: 153.67,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 311.01,
    y1: 68.9,
    x2: 242.21,
    y2: 159.4,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 302.34,
    y1: 74.43,
    x2: 254.84,
    y2: 161.66,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 9115.75,
    y1: 319.25,
    x2: 9062.08,
    y2: 377.63,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 9443.23, -48.68)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 9098.33,
    y1: 323.58,
    x2: 9103.1,
    y2: 323.58,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 9443.23, -48.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7a62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 276.33,
    y1: 386.82,
    x2: 369.91,
    y2: 305.72,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 9103.71,
    y1: 308.18,
    x2: 9050.04,
    y2: 366.56,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 9443.23, -48.68)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 9081.15,
    y1: 323.34,
    x2: 9085.27,
    y2: 323.34,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 279.35,
    y1: 390.3,
    x2: 372.93,
    y2: 309.2,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 352.99,
    y1: 240.53,
    x2: 324.77,
    y2: 349.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7ea4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93d66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 9117.96,
    y1: 199.2,
    x2: 9142.32,
    y2: 199.2,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -1804.16,
    y1: 194.18,
    x2: -1787.81,
    y2: 231.37,
    gradientTransform: "translate(2110.51 21.91) rotate(-0.54)",
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 9142.2,
    y1: 182.73,
    x2: 9149.02,
    y2: 172.24,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 374.85,
    y1: 246.21,
    x2: 346.62,
    y2: 354.87,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 9064.65,
    y1: 233.7,
    x2: 9095.48,
    y2: 233.7,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 9088.33,
    y1: 200.74,
    x2: 9100.51,
    y2: 200.74,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 8819.61,
    y1: 251.54,
    x2: 8836.62,
    y2: 322.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 9161.32, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 8807.96,
    y1: 270.29,
    x2: 8817.6,
    y2: 270.29,
    gradientTransform: "matrix(-1, 0, 0, 1, 9161.32, 0)",
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 334.85,
    y1: 259.1,
    x2: 337.4,
    y2: 269.69,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 978.41,
    y1: 1752,
    x2: 962.54,
    y2: 1772.99,
    gradientTransform: "matrix(-0.69, -0.73, -0.73, 0.69, 2294.53, -266)",
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 966.66,
    y1: 1757.07,
    x2: 985.19,
    y2: 1757.07,
    gradientTransform: "matrix(-0.69, -0.73, -0.73, 0.69, 2294.53, -266)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 955.39,
    y1: 1768.85,
    x2: 968.12,
    y2: 1755.8,
    gradientTransform: "matrix(-0.69, -0.73, -0.73, 0.69, 2294.53, -266)",
    xlinkHref: "#linear-gradient-27"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ilustracija 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M418.66,275.68c-27.55,64.85-100.92,101.19-164.56,91.39-10.35-1.6-38.74-6.35-63.87-28.76-48.38-43.15-58.72-128.58-19.7-188.79,28.41-43.82,79.33-68.66,127.71-67.41C308.66,82.37,348.6,84,383.7,113a131.25,131.25,0,0,1,26.77,30.38C434.54,181,436.61,233.41,418.66,275.68Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.27,130.17a.84.84,0,0,1-.87.79c-.89-.05-1.8-.05-2.69,0a.83.83,0,0,1-.86-.79v0a.82.82,0,0,1,.8-.85c.94,0,1.9,0,2.83,0a.83.83,0,0,1,.79.79Zm-7.91,1.21c-.88.15-1.77.34-2.63.57a.83.83,0,0,1-.42-1.61c.91-.23,1.84-.44,2.77-.6a.84.84,0,0,1,1,.68s0,.07,0,.1A.83.83,0,0,1,175.36,131.38Zm-6.77,2c-.82.35-1.64.73-2.43,1.14a.83.83,0,1,1-.77-1.47c.83-.43,1.7-.84,2.56-1.2a.83.83,0,0,1,1.09.45.66.66,0,0,1,.06.27A.82.82,0,0,1,168.59,133.34Zm-6.16,3.43c-.72.52-1.44,1.08-2.12,1.65a.83.83,0,0,1-1.17-.09.84.84,0,0,1,.1-1.17c.71-.61,1.46-1.2,2.23-1.74a.83.83,0,0,1,1.16.19.89.89,0,0,1,.15.44A.82.82,0,0,1,162.43,136.77Zm-5.24,4.71c-.59.67-1.16,1.37-1.7,2.09a.83.83,0,0,1-1.33-1c.57-.75,1.17-1.49,1.79-2.19a.83.83,0,0,1,1.17-.07.79.79,0,0,1,.28.58A.83.83,0,0,1,157.19,141.48Zm-4.06,5.76c-.44.78-.84,1.59-1.2,2.4a.83.83,0,0,1-1.1.42.82.82,0,0,1-.42-1.09c.38-.86.81-1.71,1.26-2.54a.83.83,0,0,1,1.56.36A.92.92,0,0,1,153.13,147.24Zm-.72,30.82a.83.83,0,0,1-1.12-.36c-.44-.83-.84-1.69-1.2-2.56a.83.83,0,1,1,1.53-.64c.35.83.73,1.65,1.14,2.44a.69.69,0,0,1,.09.34A.84.84,0,0,1,152.41,178.06Zm-2-24.32c-.25.86-.46,1.74-.63,2.62a.83.83,0,0,1-1,.65.82.82,0,0,1-.65-1c.18-.92.4-1.85.66-2.75a.83.83,0,0,1,1.63.18A1.24,1.24,0,0,1,150.44,153.74Zm-.8,17.63a.83.83,0,0,1-1-.6c-.23-.9-.43-1.84-.59-2.76a.83.83,0,1,1,1.64-.28c.15.88.33,1.76.56,2.63a.88.88,0,0,1,0,.16A.83.83,0,0,1,149.64,171.37Zm-.37-10.68c-.05.89-.06,1.8,0,2.69a.84.84,0,0,1-.81.86.83.83,0,0,1-.85-.79v0c0-.94,0-1.89,0-2.83a.83.83,0,0,1,1.66,0Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M156,182.19a.83.83,0,0,0-.18-.47c-.26-.34-.52-.69-.77-1a.83.83,0,1,0-1.35,1c.26.37.54.73.81,1.09a.84.84,0,0,0,1.17.15A.86.86,0,0,0,156,182.19Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.1,194.53a.83.83,0,0,0-.74-.78l-1.29-.16a.83.83,0,1,0-.24,1.64l1.35.17a.82.82,0,0,0,.91-.74A.57.57,0,0,0,178.1,194.53Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M213.89,162.35a.83.83,0,0,1-1.66,0c0-.87,0-1.76-.12-2.64a.83.83,0,0,1,1.65-.15c0,.39.06.77.08,1.15C213.87,161.26,213.89,161.81,213.89,162.35Zm-1.45-6.26a.83.83,0,0,1-1-.63c-.19-.86-.43-1.72-.69-2.56a.83.83,0,1,1,1.58-.5c.28.88.53,1.79.73,2.69a.78.78,0,0,1,0,.14A.85.85,0,0,1,212.44,156.09Zm1.16,10.77c-.13.92-.29,1.84-.49,2.74a.83.83,0,1,1-1.62-.36c.19-.86.34-1.73.46-2.6a.83.83,0,0,1,.93-.71.82.82,0,0,1,.72.78A.75.75,0,0,1,213.6,166.86Zm-3.31-17.56a.83.83,0,0,1-1.1-.4c-.38-.79-.79-1.58-1.24-2.34a.83.83,0,0,1,1.44-.83c.46.8.9,1.62,1.3,2.46a.89.89,0,0,1,.08.31A.84.84,0,0,1,210.29,149.3Zm1.54,24.64c-.32.86-.68,1.73-1.08,2.57a.83.83,0,1,1-1.5-.71c.37-.8.72-1.62,1-2.44a.83.83,0,0,1,1.07-.49.84.84,0,0,1,.54.74A.76.76,0,0,1,211.83,173.94Zm-3.28,6.52c-.5.78-1,1.54-1.61,2.27a.83.83,0,1,1-1.31-1c.54-.69,1.05-1.42,1.53-2.15a.83.83,0,0,1,1.15-.25.86.86,0,0,1,.38.65A.83.83,0,0,1,208.55,180.46Zm-4.62,5.65c-.66.65-1.35,1.28-2.06,1.87a.84.84,0,0,1-1.17-.11.82.82,0,0,1,.11-1.17c.67-.56,1.33-1.16,2-1.77a.83.83,0,0,1,1.18,0,.85.85,0,0,1,.23.53A.83.83,0,0,1,203.93,186.11Zm-5.74,4.51c-.78.49-1.6.95-2.43,1.37a.83.83,0,0,1-.75-1.48c.78-.4,1.56-.84,2.31-1.3a.83.83,0,0,1,1.14.27.69.69,0,0,1,.12.39A.82.82,0,0,1,198.19,190.62Zm-6.59,3.14c-.88.3-1.77.57-2.67.8a.83.83,0,1,1-.41-1.61c.85-.22,1.7-.47,2.53-.76a.83.83,0,0,1,1.06.51.62.62,0,0,1,0,.23A.84.84,0,0,1,191.6,193.76Zm-7.12,1.61c-.68.08-1.36.13-2,.17l-.74,0a.81.81,0,0,1-.85-.8.83.83,0,0,1,.8-.86l.7,0c.65,0,1.3-.09,1.94-.16a.83.83,0,0,1,.92.73v.05A.82.82,0,0,1,184.48,195.37Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M207,142.43a.83.83,0,0,0-.18-.46c-.28-.36-.57-.71-.86-1.06a.83.83,0,1,0-1.26,1.08c.28.33.55.66.82,1a.83.83,0,0,0,1.16.14A.85.85,0,0,0,207,142.43Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M192.88,140.71a.37.37,0,0,0-.45,0l-3.88,2.69a20.53,20.53,0,0,0-6.48-1.58l-2.2-4.17a.4.4,0,0,0-.4-.21l-5.6.87a.38.38,0,0,0-.32.31l-.84,4.65a20.75,20.75,0,0,0-5.7,3.46l-4.51-1.39a.39.39,0,0,0-.43.14l-3.34,4.57a.39.39,0,0,0,0,.45l2.7,3.88a20.26,20.26,0,0,0-1.58,6.48l-4.18,2.2a.38.38,0,0,0-.2.4l.86,5.6a.41.41,0,0,0,.32.32l4.64.84a20.54,20.54,0,0,0,3.47,5.7l-1.4,4.51a.4.4,0,0,0,.15.43l4.57,3.34a.39.39,0,0,0,.45,0l3.88-2.7a20.27,20.27,0,0,0,6.47,1.58l2.21,4.18a.36.36,0,0,0,.4.2l5.6-.87a.38.38,0,0,0,.32-.31l.84-4.64a20.48,20.48,0,0,0,5.69-3.47l4.51,1.4a.4.4,0,0,0,.43-.15l3.35-4.57a.39.39,0,0,0,0-.45l-2.69-3.88a20.53,20.53,0,0,0,1.58-6.47l4.17-2.21a.38.38,0,0,0,.21-.4l-.87-5.6a.39.39,0,0,0-.31-.32l-4.65-.84A20.69,20.69,0,0,0,196.2,149l1.39-4.51a.39.39,0,0,0-.14-.43Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M186.14,163a5.67,5.67,0,1,1,0-.84A5.89,5.89,0,0,1,186.14,163Zm-9,2.25a4.32,4.32,0,0,0,2.95,1.56,4.36,4.36,0,1,0-3.93-4.75,4.71,4.71,0,0,0,0,.65A4.36,4.36,0,0,0,177.11,165.24Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M194.38,161.84c0-.48-.08-1-.15-1.43h0c0-.15,0-.3-.08-.45a13.34,13.34,0,0,0-.58-2.17v0l0-.08-.06-.15a.36.36,0,0,0-.33-.22l-.1,0a.33.33,0,0,0-.19.43,13.57,13.57,0,0,1,.72,2.75,13.34,13.34,0,0,1-11.14,15.22,12.54,12.54,0,0,1-1.36.14,13.34,13.34,0,0,1-2.72-26.5,12.36,12.36,0,0,1,1.35-.14,13.28,13.28,0,0,1,5.71,1,.36.36,0,0,0,.14,0,.31.31,0,0,0,.29-.2.34.34,0,0,0-.18-.44,14,14,0,0,0-6-1,13.38,13.38,0,0,0-1.42.14,14,14,0,0,0,2.85,27.82,13.57,13.57,0,0,0,1.43-.14,14,14,0,0,0,11.85-14.55Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M190.37,86.28a.51.51,0,0,0-.39-.47q-.64-.15-1.29-.27a.52.52,0,0,0-.59.42.51.51,0,0,0,.41.59c.41.08.83.16,1.23.26a.53.53,0,0,0,.62-.38A.76.76,0,0,0,190.37,86.28Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M186.46,85.78a.51.51,0,0,1-.53.49,19.28,19.28,0,0,0-2.15,0l-.46,0a.51.51,0,0,1-.55-.48.53.53,0,0,1,.48-.54,3.71,3.71,0,0,1,.47,0,21.3,21.3,0,0,1,2.26,0,.51.51,0,0,1,.48.49A0,0,0,0,1,186.46,85.78Zm-5.72.87a21.7,21.7,0,0,0-2.52.66.5.5,0,0,1-.64-.33.5.5,0,0,1,.32-.64,21.83,21.83,0,0,1,2.64-.7.53.53,0,0,1,.61.41v.07A.51.51,0,0,1,180.74,86.65Zm-4.93,1.63a19.43,19.43,0,0,0-2.28,1.26.51.51,0,1,1-.55-.87,21.34,21.34,0,0,1,2.39-1.32.52.52,0,0,1,.68.24.73.73,0,0,1,0,.2A.52.52,0,0,1,175.81,88.28Zm-4.39,2.79a20,20,0,0,0-1.9,1.78.51.51,0,0,1-.75-.7,23.54,23.54,0,0,1,2-1.87.51.51,0,0,1,.72.07.56.56,0,0,1,.12.3A.55.55,0,0,1,171.42,91.07Zm-3.57,3.78A20.93,20.93,0,0,0,166.44,97a.52.52,0,0,1-.7.19.51.51,0,0,1-.19-.7A22.84,22.84,0,0,1,167,94.24a.51.51,0,0,1,.72-.11.53.53,0,0,1,.21.39A.51.51,0,0,1,167.85,94.85Zm-2.54,4.53a21.61,21.61,0,0,0-.84,2.46.5.5,0,0,1-.63.36.51.51,0,0,1-.36-.63,21.79,21.79,0,0,1,.88-2.58.51.51,0,0,1,1,.17A.42.42,0,0,1,165.31,99.38Zm-1.36,5a22.59,22.59,0,0,0-.21,2.6.51.51,0,0,1-.52.5.51.51,0,0,1-.5-.52,22.33,22.33,0,0,1,.21-2.72.52.52,0,0,1,.58-.44.51.51,0,0,1,.44.48Zm0,8.38a.51.51,0,0,1-.62-.38c-.17-.76-.31-1.55-.41-2.34,0-.12,0-.23,0-.35a.51.51,0,1,1,1-.11c0,.11,0,.22,0,.34a20.79,20.79,0,0,0,.39,2.23s0,.06,0,.09A.52.52,0,0,1,163.91,112.77Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M207,106.51a24,24,0,0,1-.06,2.68.51.51,0,0,1-1-.08,19.89,19.89,0,0,0,.05-2.56.51.51,0,0,1,.49-.53.52.52,0,0,1,.54.48Zm-.7-2.09a.5.5,0,0,1-.58-.42,23.75,23.75,0,0,0-.56-2.5.52.52,0,0,1,.35-.64.51.51,0,0,1,.63.35,21.28,21.28,0,0,1,.59,2.63v0A.49.49,0,0,1,206.3,104.42Zm.26,7.43a22.45,22.45,0,0,1-.7,2.59.51.51,0,0,1-.65.32.52.52,0,0,1-.33-.65,18.74,18.74,0,0,0,.67-2.47.53.53,0,0,1,.61-.4.52.52,0,0,1,.41.48A.57.57,0,0,1,206.56,111.85ZM205,99.36a.52.52,0,0,1-.67-.28,22.19,22.19,0,0,0-1.14-2.29.52.52,0,0,1,.18-.7.51.51,0,0,1,.7.19,21.56,21.56,0,0,1,1.21,2.4,1.16,1.16,0,0,1,0,.18A.52.52,0,0,1,205,99.36Zm-.13,17.57a21.4,21.4,0,0,1-1.3,2.34.51.51,0,0,1-.87-.55,21.32,21.32,0,0,0,1.25-2.24.51.51,0,0,1,1,.2A.45.45,0,0,1,204.84,116.93ZM202,121.45a21.22,21.22,0,0,1-1.83,2,.5.5,0,0,1-.72,0,.51.51,0,0,1,0-.72,20.72,20.72,0,0,0,1.75-1.88.52.52,0,0,1,.91.3A.6.6,0,0,1,202,121.45Zm-3.88,3.69a21.7,21.7,0,0,1-2.25,1.47.51.51,0,1,1-.51-.89,20.17,20.17,0,0,0,2.14-1.4.51.51,0,0,1,.72.11.47.47,0,0,1,.1.27A.5.5,0,0,1,198.08,125.14Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M202.65,94.3a.59.59,0,0,0-.1-.28c-.27-.35-.55-.69-.83-1a.51.51,0,0,0-.72-.06.52.52,0,0,0-.06.72c.27.32.53.65.79,1a.51.51,0,0,0,.92-.34Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M193,92.84a.27.27,0,0,0-.31,0l-2.59,1.81a13.55,13.55,0,0,0-4.33-1.06l-1.48-2.8a.26.26,0,0,0-.27-.13l-3.74.58a.27.27,0,0,0-.22.21l-.56,3.11a13.8,13.8,0,0,0-3.81,2.32l-3-.94a.27.27,0,0,0-.29.1l-2.24,3.06a.27.27,0,0,0,0,.3l1.8,2.59a13.8,13.8,0,0,0-1.05,4.34l-2.8,1.47a.25.25,0,0,0-.13.27l.58,3.75a.24.24,0,0,0,.21.21l3.11.56a13.53,13.53,0,0,0,2.31,3.81l-.93,3a.28.28,0,0,0,.09.29l3.06,2.24a.29.29,0,0,0,.31,0l2.59-1.8a13.82,13.82,0,0,0,4.33,1.06L185.1,124a.27.27,0,0,0,.27.14l3.74-.58a.28.28,0,0,0,.22-.21l.56-3.11a13.8,13.8,0,0,0,3.81-2.32l3,.93a.25.25,0,0,0,.29-.09l2.24-3.06a.27.27,0,0,0,0-.3l-1.8-2.6a13.81,13.81,0,0,0,1.05-4.33l2.8-1.48a.24.24,0,0,0,.13-.26l-.58-3.75a.25.25,0,0,0-.21-.22l-3.11-.56a13.53,13.53,0,0,0-2.31-3.81l.93-3a.27.27,0,0,0-.09-.28Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M188.56,107.75a3.9,3.9,0,0,1-1.39,2.63,3.88,3.88,0,1,1,1.4-3.2A5.42,5.42,0,0,1,188.56,107.75Zm-4.13,2.48a2.87,2.87,0,0,0,2.09-.64,2.92,2.92,0,0,0,1-1.94h0a2.86,2.86,0,0,0-2.58-3.1,2.86,2.86,0,0,0-3.11,2.57,2.94,2.94,0,0,0,0,.42A2.85,2.85,0,0,0,184.43,110.23Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M194.29,107c0-.33,0-.65-.1-1a9.49,9.49,0,0,0-.5-1.9l0-.09a.52.52,0,0,0-.5-.33l-.16,0a.51.51,0,0,0-.3.66,8.34,8.34,0,0,1,.47,1.78h0s0,.06,0,.1a8.53,8.53,0,0,1-.44,4.2,9.06,9.06,0,0,1-1.09,2.06h0l0,0A8.57,8.57,0,0,1,186,116a6.56,6.56,0,0,1-.88.09,8.63,8.63,0,0,1-1.76-17.15,6.42,6.42,0,0,1,.87-.09,8.5,8.5,0,0,1,3.7.62.42.42,0,0,0,.22,0,.51.51,0,0,0,.17-1,9.62,9.62,0,0,0-4.14-.7c-.32,0-.65,0-1,.1a9.66,9.66,0,0,0,2,19.2c.33,0,.66,0,1-.1A9.68,9.68,0,0,0,194.29,107Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M408.85,104.84a1.47,1.47,0,0,0-2.28-1.62c-11.59,8.65-40.11,35.24-39.69,87.43.53,65.47-15.6,87.5-34,100,0,0,23.77-4.15,41-26.42C416.05,209.54,401.05,128.93,408.85,104.84Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M398.59,124.1c-2.13,7-4.12,14.12-5.84,21.26s-3.31,14.32-4.63,21.53-2.45,14.47-3.3,21.76-1.45,14.59-2,21.93-1.13,14.73-2.43,22.09A74.88,74.88,0,0,1,373.45,254c-.87,1.67-1.77,3.32-2.75,4.91s-2,3.18-3.05,4.72a77.52,77.52,0,0,1-24.46,22.87,1.42,1.42,0,0,1-1.5-2.42h0c1.53-1,3.05-2,4.51-3,.74-.52,1.46-1.07,2.19-1.61s1.43-1.1,2.12-1.68a74.49,74.49,0,0,0,7.84-7.44,82,82,0,0,0,12.31-17.74,70.37,70.37,0,0,0,4.13-10,81.45,81.45,0,0,0,2.64-10.5c1.33-7.14,1.93-14.45,2.56-21.78s1.35-14.69,2.35-22q.74-5.49,1.67-11c.3-1.82.63-3.64,1-5.46s.71-3.62,1.09-5.43q2.26-10.85,5.19-21.52c2-7.1,4.17-14.15,6.61-21.1a.39.39,0,0,1,.49-.24A.4.4,0,0,1,398.59,124.1Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M359.61,340.63a3.7,3.7,0,0,0,5.62,2.47c12.23-7.74,44.85-32.76,50.75-82.38,5-41.91,11.68-64.17,15.41-74.06A2.31,2.31,0,0,0,428,183.9C407.25,197.29,343.12,247,359.61,340.63Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M363.11,341.27l.15.12a1,1,0,0,0,1.42-.32c.34-.54,34.51-54.79,44.07-112.75a1,1,0,1,0-2-.33c-9.5,57.53-43.44,111.45-43.78,112A1,1,0,0,0,363.11,341.27Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M185.13,132.64a17.58,17.58,0,0,1,17.59-17.58H352.29a15.5,15.5,0,0,1,15.48,14.7l11,216.86a11.43,11.43,0,0,1-11.21,12l-171.43,3.11a10.84,10.84,0,0,1-11-10.84Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M221.23,358.06h0L202,357.81A11.83,11.83,0,0,1,190.41,346v-29a.41.41,0,1,1,.81,0v29a11,11,0,0,0,10.83,11l19.18.25a.4.4,0,0,1,.4.41A.4.4,0,0,1,221.23,358.06Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M190.81,308.5a.4.4,0,0,1-.4-.41V303.4a.41.41,0,1,1,.81,0v4.69A.41.41,0,0,1,190.81,308.5Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M197.38,118.39a5.11,5.11,0,0,1,5.8-5.09c20.42,2.77,90.66,11.33,148.73,6.88a4.72,4.72,0,0,1,5.09,4.45l11.58,217.83a5.43,5.43,0,0,1-5.11,5.71c-24.42,1.45-125,7-160.89,3.28a4.31,4.31,0,0,1-3.85-4.26Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M199.79,123.85a4.91,4.91,0,0,1,5.57-4.9c19.66,2.66,87.25,10.91,143.14,6.62a4.55,4.55,0,0,1,4.9,4.29l11.14,209.62a5.23,5.23,0,0,1-4.92,5.5c-23.5,1.39-120.3,6.77-154.83,3.15a4.15,4.15,0,0,1-3.71-4.1Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M218,140,220.07,185a2.86,2.86,0,0,0,2.77,2.73c8.33.23,34.26.87,48.91.1a3.19,3.19,0,0,0,3-3.08c.28-8.43.89-33-1-43.21a3.6,3.6,0,0,0-3.42-2.93l-49.2-1.72A3,3,0,0,0,218,140Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M341.23,143.93a1.5,1.5,0,0,0,1.54-1.51,1.65,1.65,0,0,0-1.63-1.54l-54.28-1a1,1,0,0,0-1.06,1.47l.37,1.05a2.41,2.41,0,0,0,2.12,1.5Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M286.86,148.29a1,1,0,0,0-1.06,1.47l.37,1.05a2.41,2.41,0,0,0,2.12,1.49h52.94a1.5,1.5,0,0,0,1.54-1.5,1.65,1.65,0,0,0-1.63-1.54Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M286.86,156.79a1,1,0,0,0-1.06,1.47l.37,1.05a2.41,2.41,0,0,0,2.12,1.49h52.94a1.5,1.5,0,0,0,1.54-1.5,1.65,1.65,0,0,0-1.63-1.54Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M286.86,166.47a1,1,0,0,0-1.06,1.47l.37,1a2.41,2.41,0,0,0,2.12,1.5h52.94a1.5,1.5,0,0,0,1.54-1.51,1.65,1.65,0,0,0-1.63-1.54Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M286.86,176a1,1,0,0,0-1.06,1.47l.37,1a2.4,2.4,0,0,0,2.12,1.5h52.94a1.5,1.5,0,0,0,1.54-1.51,1.63,1.63,0,0,0-1.63-1.53Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M346.47,201.79a1.42,1.42,0,0,0,1.48-1.5,1.69,1.69,0,0,0-1.68-1.52l-126.71-1c-.88,0-1.15.54-.6,1.23l1.24,1.55a3.73,3.73,0,0,0,2.57,1.24Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M219.56,206.15c-.88,0-1.15.54-.6,1.22l1.24,1.56a3.73,3.73,0,0,0,2.57,1.24h123.7a1.43,1.43,0,0,0,1.48-1.51,1.69,1.69,0,0,0-1.68-1.52Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M219.15,220.13c3-.23,8.73-.34,11.86-.38a2.83,2.83,0,0,1,2.8,2.17,46.24,46.24,0,0,1,1.34,11.47,2.52,2.52,0,0,1-2.55,2.47l-11.55-.13a2.77,2.77,0,0,1-2.74-2.51l-1-10.88A2,2,0,0,1,219.15,220.13Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M240.36,224.59A1.27,1.27,0,0,0,239,226.1l.33,2.19a1.91,1.91,0,0,0,1.82,1.57h28.41a1.58,1.58,0,0,0,1.57-1.59v-.8a1.72,1.72,0,0,0-1.61-1.66Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M282.12,220.13c3-.23,8.73-.34,11.87-.38a2.84,2.84,0,0,1,2.8,2.17,46.31,46.31,0,0,1,1.33,11.47,2.52,2.52,0,0,1-2.54,2.47L284,235.73a2.78,2.78,0,0,1-2.74-2.51l-1-10.88A2,2,0,0,1,282.12,220.13Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M303.34,224.59A1.26,1.26,0,0,0,302,226.1l.32,2.19a1.91,1.91,0,0,0,1.83,1.57h28.4a1.58,1.58,0,0,0,1.57-1.59v-.8a1.7,1.7,0,0,0-1.61-1.66Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M235.46,263.28h0l-10.67-.1a2.87,2.87,0,0,1-2.92-2.44l-.94-9a2,2,0,0,1,.46-1.46,2.32,2.32,0,0,1,1.63-.81h0c.9-.06,2.17-.17,3.51-.28,2.82-.24,6.33-.54,8.3-.57a3,3,0,0,1,3,2.09c.56,2.06.51,5.95.4,10.09A2.64,2.64,0,0,1,235.46,263.28Zm-12.41-12.94a1.49,1.49,0,0,0-1.06.51,1.09,1.09,0,0,0-.27.85l.93,8.95a2.05,2.05,0,0,0,2.12,1.71l10.67.1h0a1.82,1.82,0,0,0,1.91-1.63c.11-4.08.16-7.91-.37-9.85a2.21,2.21,0,0,0-2.19-1.49c-1.94,0-5.44.32-8.24.56-1.35.12-2.62.23-3.52.29Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M224.2,251.26c2.24-.15,7.11-.65,9.42-.67a2,2,0,0,1,2.06,1.42c.45,1.65.39,4.94.31,8a1.76,1.76,0,0,1-1.87,1.62l-8.53-.08a2,2,0,0,1-2-1.65l-.75-7.16A1.38,1.38,0,0,1,224.2,251.26Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M244.83,257.34a2.65,2.65,0,0,0,2.58,2l98.69-.84a2,2,0,0,0,0-4L247.4,254A2.65,2.65,0,0,0,244.83,257.34Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M224.65,252.67h0a1.64,1.64,0,0,1,2.26.61l2.1,3.77a.53.53,0,0,0,.94,0l5.22-11.62a.58.58,0,0,1,1.11.25,22.92,22.92,0,0,1-6.67,16s-3.13-1.22-5.65-6.75A1.71,1.71,0,0,1,224.65,252.67Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M235.46,286.14h0l-10.67-.1a2.87,2.87,0,0,1-2.92-2.44l-.94-9a2,2,0,0,1,.46-1.46,2.36,2.36,0,0,1,1.63-.81h0c.9-.06,2.17-.17,3.51-.28,2.82-.24,6.33-.54,8.3-.57h0a3,3,0,0,1,2.94,2.09c.56,2.06.51,5.95.4,10.09A2.63,2.63,0,0,1,235.46,286.14ZM223.05,273.2a1.53,1.53,0,0,0-1.06.51,1.09,1.09,0,0,0-.27.85l.93,8.95a2.05,2.05,0,0,0,2.12,1.71l10.67.1h0a1.82,1.82,0,0,0,1.91-1.63c.11-4.08.16-7.9-.37-9.85a2.2,2.2,0,0,0-2.19-1.49c-1.94,0-5.44.33-8.24.56-1.35.12-2.62.23-3.52.29Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M224.2,274.12c2.24-.15,7.11-.65,9.42-.67a2.05,2.05,0,0,1,2.06,1.42c.45,1.65.39,4.94.31,8a1.76,1.76,0,0,1-1.87,1.62l-8.53-.08a2,2,0,0,1-2-1.65l-.75-7.16A1.38,1.38,0,0,1,224.2,274.12Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M244.83,280.2a2.65,2.65,0,0,0,2.58,2l98.69-.84a2,2,0,0,0,0-4l-98.69-.45A2.65,2.65,0,0,0,244.83,280.2Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M224.65,275.53h0a1.64,1.64,0,0,1,2.26.61l2.1,3.77a.52.52,0,0,0,.94,0l5.22-11.62a.58.58,0,0,1,1.11.26,22.91,22.91,0,0,1-6.67,16s-3.13-1.22-5.65-6.75A1.71,1.71,0,0,1,224.65,275.53Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M235.46,309h0l-10.67-.1a2.86,2.86,0,0,1-2.92-2.44l-.94-8.95a2,2,0,0,1,.46-1.46,2.36,2.36,0,0,1,1.63-.81h0c.9-.06,2.17-.17,3.51-.28,2.82-.24,6.33-.54,8.3-.56h0a3,3,0,0,1,2.94,2.09c.56,2.06.51,5.95.4,10.09A2.63,2.63,0,0,1,235.46,309Zm-12.41-12.94a1.53,1.53,0,0,0-1.06.51,1.1,1.1,0,0,0-.27.86l.93,8.94a2,2,0,0,0,2.12,1.71l10.67.1h0a1.82,1.82,0,0,0,1.91-1.63c.11-4.08.16-7.9-.37-9.85a2.2,2.2,0,0,0-2.19-1.49c-1.94,0-5.44.33-8.24.57-1.35.11-2.62.22-3.52.28Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M224.2,297c2.24-.15,7.11-.64,9.42-.67a2.05,2.05,0,0,1,2.06,1.42c.45,1.65.39,4.94.31,8a1.76,1.76,0,0,1-1.87,1.62l-8.53-.08a2,2,0,0,1-2-1.65l-.75-7.15A1.39,1.39,0,0,1,224.2,297Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M244.83,303.06a2.65,2.65,0,0,0,2.58,2l98.69-.84a2,2,0,0,0,0-4l-98.69-.45A2.65,2.65,0,0,0,244.83,303.06Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M224.65,298.39h0a1.64,1.64,0,0,1,2.26.61l2.1,3.77a.52.52,0,0,0,.94,0l5.22-11.62a.58.58,0,0,1,1.11.26,22.91,22.91,0,0,1-6.67,16s-3.13-1.22-5.65-6.75A1.71,1.71,0,0,1,224.65,298.39Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M235.46,331.86h0l-10.67-.1a2.86,2.86,0,0,1-2.92-2.44l-.94-8.95a2,2,0,0,1,.46-1.46,2.36,2.36,0,0,1,1.63-.81h0c.9-.06,2.17-.17,3.51-.28,2.82-.24,6.33-.54,8.3-.56h0a3,3,0,0,1,2.94,2.09c.56,2,.51,5.94.4,10.08A2.63,2.63,0,0,1,235.46,331.86Zm-12.41-12.94a1.5,1.5,0,0,0-1.06.52,1.07,1.07,0,0,0-.27.85l.93,8.95a2,2,0,0,0,2.12,1.7l10.67.1h0a1.82,1.82,0,0,0,1.91-1.63c.11-4.08.16-7.9-.37-9.85a2.18,2.18,0,0,0-2.19-1.48c-1.94,0-5.44.32-8.24.56-1.35.11-2.62.22-3.52.28Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M224.2,319.84c2.24-.15,7.11-.64,9.42-.67a2.06,2.06,0,0,1,2.06,1.43c.45,1.64.39,4.93.31,8a1.77,1.77,0,0,1-1.87,1.63l-8.53-.09a2,2,0,0,1-2-1.65l-.75-7.15A1.39,1.39,0,0,1,224.2,319.84Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M244.83,325.92h0a2.65,2.65,0,0,0,2.58,2l98.69-.84a2,2,0,0,0,0-4l-98.69-.45A2.64,2.64,0,0,0,244.83,325.92Z",
    transform: "translate(-146.64 -82.06)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M224.65,321.25h0a1.64,1.64,0,0,1,2.26.61l2.1,3.77a.52.52,0,0,0,.94,0L235.17,314a.58.58,0,0,1,1.11.25,22.9,22.9,0,0,1-6.67,16s-3.13-1.22-5.65-6.75A1.71,1.71,0,0,1,224.65,321.25Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M286.78,85.49c-5.4-3.76-10.1-3.69-13.41-2.71a6.59,6.59,0,0,0-4.68,6.93l1.42,15.57,17,1.51S297.38,92.86,286.78,85.49Zm-7.46,12.56a4.24,4.24,0,1,1,4.23-4.24A4.24,4.24,0,0,1,279.32,98.05Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M271.81,98.73a.41.41,0,0,1-.41-.37l-.23-2.48a.41.41,0,0,1,.82-.07l.23,2.48a.41.41,0,0,1-.37.44Zm-.45-4.86a.4.4,0,0,1-.4-.37l-.18-1.88A6.32,6.32,0,0,1,275.25,85a12.75,12.75,0,0,1,6.2-.25.41.41,0,0,1-.16.8,11.9,11.9,0,0,0-5.81.24,5.47,5.47,0,0,0-3.88,5.75l.17,1.88a.4.4,0,0,1-.37.44Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M247,115.34v-7.82a4.78,4.78,0,0,1,4.94-4.78l54,1.85a4.64,4.64,0,0,1,4.48,4.36l.45,7.53Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M267.07,105.69h-2.32a.41.41,0,0,1-.41-.41.41.41,0,0,1,.41-.41h2.32a.41.41,0,0,1,.41.41A.41.41,0,0,1,267.07,105.69Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M249.87,112.88a.41.41,0,0,1-.41-.41v-3.16a4.44,4.44,0,0,1,4.44-4.44h8.53a.41.41,0,0,1,.41.41.41.41,0,0,1-.41.41H253.9a3.62,3.62,0,0,0-3.62,3.62v3.16A.41.41,0,0,1,249.87,112.88Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M225,117.32a5.09,5.09,0,0,1,5.08-4.84H324.4a7,7,0,0,1,6.88,5.79l.08.46a6,6,0,0,1-5.91,7h-96.8a3.89,3.89,0,0,1-3.89-4.08Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M347.52,361.35s.59,3.14.89,6.26a2.14,2.14,0,0,1-2,2.34c-4.15.21-13,.63-16.21.52a.7.7,0,0,1-.62-1,1.6,1.6,0,0,1,.79-.85l14.6-6.88Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M348,359.5l-.41,3.77s-2.56,1.22-4.32-.11l1-4.21Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M347,288.73c.2,1,1.5,49-3.43,70.64a.72.72,0,0,0,.44.84,12.46,12.46,0,0,0,4.19.81,1.25,1.25,0,0,0,1.24-.91c1.42-5,8.22-30.12,8.91-54.05.77-26.74,0-.91,0-.91l-.76-16.52Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M364.4,362.83a22.7,22.7,0,0,1,1.8,5.8,1.31,1.31,0,0,1-1.14,1.57c-1.37.15-3.48.35-5.17.35a1.3,1.3,0,0,1-1.3-1.44A11,11,0,0,1,361.1,363Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M365.13,358l-1,5.71a3.71,3.71,0,0,1-3.07.24l.44-6.13Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M367.3,290c4.44,25.33-.31,62.7-2,70a1.13,1.13,0,0,1-.91.87,7.59,7.59,0,0,1-3.29-.1,1,1,0,0,1-.76-.95c-.29-5.9-.22-42.17-4.27-56.46a3.22,3.22,0,0,0-1.27-1.78l-7.65-5.33-.67-8.73Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M340.06,242.21c12.6-.33,26.53,3,26.53,3,4,21.87,1.1,47.17,1.1,47.17-9.72,2.65-20.76-1.37-20.76-1.37-1.71-9.14-9.52-34.83-9.52-34.83A41.54,41.54,0,0,1,322,251.49a27,27,0,0,0,5.23-11.22A42.06,42.06,0,0,0,340.06,242.21Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M302.68,224a2.42,2.42,0,0,1,2.8-.81c1.93,7.81,11.71,14.07,21.72,17.07A27,27,0,0,1,322,251.49C305.31,242.33,302.68,224,302.68,224Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M303,224.39c-.13.41,1.38,1,2.24-.67,0-.8.48-4.26,0-4.92a64.54,64.54,0,0,0-7.62-7.81,1.19,1.19,0,0,0-.14,1.65l2.44,2.49a12,12,0,0,0-1.38,2.8,3.39,3.39,0,0,0,.36,2.49c.43.76,1,1.74,1.57,2.51A3.36,3.36,0,0,0,303,224.39Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M301,216.75l2.22,1.84.71,1.86L302,222.64a25,25,0,0,0-1.19-4.47C300.28,217.38,300.53,217,301,216.75Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M361.87,257.51l4.72-12.25s11.84,7.89,13.87,18a27.89,27.89,0,0,0-10.2,2.84C369.34,261.32,361.87,257.51,361.87,257.51Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M351.7,269.08s13.28,7.34,17.67.92a5,5,0,0,0,.89-3.9,27.89,27.89,0,0,1,10.2-2.84,14,14,0,0,1-1.43,9.6c-7.67,14.36-29-.51-29-.51Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M352.72,231.86l4.12,11.55a.42.42,0,0,1-.19.51,9.42,9.42,0,0,1-9.77-.56A2,2,0,0,1,346,242l-1.39-10Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M354.41,280.68l-7.23-25.27a.76.76,0,0,0-.62-.53c-1.31-.15-5.11-.58-9.5-.95a106.88,106.88,0,0,0-15.08-.5.74.74,0,0,0-.6,1.06c2.08,4.22,10.66,21.37,14.95,27a.74.74,0,0,0,.6.3l16.78-.16A.73.73,0,0,0,354.41,280.68Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M352.67,274.57s1-4.14.6-5.61-1.2-3.36-3.82-2.94a37.93,37.93,0,0,0-5.72,1.53,1.5,1.5,0,0,0,2.15,1.29l-1.24,1s.18,1.53,1.86.71l-1.15,1.27a1.35,1.35,0,0,0,2,.45C348.56,271.43,349.15,275.07,352.67,274.57Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M337.55,261.47a2.13,2.13,0,1,1-2.13-2.12A2.13,2.13,0,0,1,337.55,261.47Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M346.36,262.87l-1.47-5a1.72,1.72,0,0,0-1.29-1.21c-4.61-1-17.25-1.16-17.38-1.17v-.56c.52,0,12.82.21,17.49,1.18a2.28,2.28,0,0,1,1.71,1.6l1.47,5Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M346.28,220.1c-.14.14-6.06,12.47-6.06,12.47l6.71,3.44,7.25-10.8S348.69,217.7,346.28,220.1Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M351.21,225.51a1.19,1.19,0,0,1-.08,1l-3.35,5.92a1.08,1.08,0,0,1-.18.24c-.4.4-1.76,1.54-2.82,0a9.84,9.84,0,0,0-2.64-3,1,1,0,0,0-1.44.5,42.74,42.74,0,0,0-2.29,5.77,1.14,1.14,0,0,0,.62,1.38,28,28,0,0,0,6.42,2,1,1,0,0,0,1-.46c1-1.49,3.92-5.65,4.9-6.69s2.61-.6,3.37-.37a1,1,0,0,0,.86-.12,2.57,2.57,0,0,0,.88-3.81,1.18,1.18,0,0,1,.34-1.54,2.58,2.58,0,0,0,.9-3.56,3.26,3.26,0,0,0-3.61-1.88,1.11,1.11,0,0,1-1.17-.69.72.72,0,0,0-.55-.46,1.1,1.1,0,0,1-.84-1.29A3,3,0,0,0,350,215c-2.9-1.68-5.43,1.07-6.08,3.39s2.6,4,4.63,4.24C350.06,222.87,350.88,224.6,351.21,225.51Z",
    transform: "translate(-146.64 -82.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M350.11,234.27s1.28-4,2.93-3.85,2.95,1.89.9,3.85C351.4,236.7,350.11,234.27,350.11,234.27Z",
    transform: "translate(-146.64 -82.06)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.f4b9be0c8194106d4a7aab17f8e129cb.svg";
export { ForwardRef as ReactComponent };